
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F","stroke-linecap":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M4.5 12.5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1m-3 13h5a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1Z"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"stroke-linejoin":"round","d":"M8.5 12.5h1"}}),_c('path',{staticClass:"i-stroke_3",attrs:{"stroke-linejoin":"round","d":"M8.5 9.5h3m-3-2h3"}})])])
          )
        }
      }
    